import {
  IReqCertDownload,
  IReqCertVerify,
  IResCertDownload,
  IResCertVerify,
} from 'src/types/api/certificateApiTypes';
import { Api } from '../config';

export const certificateServiceProvider = () => {
  /**
   * 取得API HealthCheck結果。
   */
  const getHealthStatus = async () => {
    const res = await Api().get('/Certificate/getStatus');
    return res.data as string;
  };
  /**
   * 電子證書驗證。
   */
  const getCertVerify = async (params: IReqCertVerify) => {
    const res = await Api({
      'Content-Type': 'multipart/form-data',
    }).post('/Certificate/verify', params);

    return res.data as IResCertVerify;
  };
  /**
   * 電子證書下載。
   */
  const getCertDownload = async (params: IReqCertDownload) => {
    const res = await Api().get('/Certificate/getUrl', { params });
    return res.data as IResCertDownload;
  };

  return { getHealthStatus, getCertVerify, getCertDownload };
};
